/* eslint-disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: pdp-page
// ==============================
import 'build/nImyp9w96Umuthqsite/sass/core.scss'
import * as commandQueue from 'init/command-queue'
import globalStore from 'init/global-store'
import { checkTurntoflow } from 'email-flows/turntoflow-check'
import { dropAllCookies, dropTargetingCookies } from 'util/cookie-utils'
import { loadConfig as loadGlobalConfig } from 'init/global.config'
import loadIcons from 'util/browser/load-icons'
import { loadMessages } from 'services/msg'
import * as instantAnswersLoader from 'widgets/instant-answers/instant-answers-loader'
import * as qaLoader from 'widgets/qa/qa-loader'
import * as reviewsSummaryLoader from 'widgets/reviews-summary/reviews-summary-loader'
import * as reviewsListLoader from 'widgets/reviews-list/reviews-list-loader'
import * as chatterLoader from 'widgets/chatter/chatter-loader'
import * as topCommentsLoader from 'widgets/top-comments/top-comments-loader'
import * as galleryLoader from 'widgets/gallery/gallery-loader'
import { loadConfig as loadReviewSubmissionConfig } from 'widgets/submission/review-submission.config'
import tokenService from 'services/token-service'
import { turnToConfig } from 'init/config'
import waitForValue from 'util/wait-for-value'

if (turnToConfig.sku) {
  globalStore.sku = turnToConfig.sku
}
if (turnToConfig.disableAllCookies) {
  globalStore.disableAllCookies = true
  dropAllCookies()
}
if (turnToConfig.disableTargetingCookies) {
  globalStore.disableTargetingCookies = true
  dropTargetingCookies()
}

function loadConfig(config) {
  // design editor inserts the icons to handle dynamic changes to icons
  if (!process.env.forThemer) {
    loadIcons(config.svg)
  }
  loadMessages(config.messages, config.pluralRuleFn)
  loadGlobalConfig(config.globalConfig)
  Promise.all([
    instantAnswersLoader.loadWidget(config.instantAnswers),
    qaLoader.loadWidget(config.qa),
    reviewsSummaryLoader.loadWidget(config.reviewsSummary),
    reviewsListLoader.loadWidget(config.reviewsList),
    chatterLoader.loadWidget(config.chatter),
    topCommentsLoader.loadWidget(config.topComments),
    galleryLoader.loadWidget(config.gallery)
  ]).then(() => {
    globalStore.loaders = [
      instantAnswersLoader,
      qaLoader,
      reviewsSummaryLoader,
      reviewsListLoader,
      chatterLoader,
      topCommentsLoader,
      galleryLoader
    ]
    commandQueue.init()
  })
  tokenService.loadLoggedInUser()
  loadReviewSubmissionConfig(config.reviewSubmission)
  checkTurntoflow()
}

// design editor may manipluate the config based on user inputs.  Need to make those changes before the widgets load.
// This allows the widgets to kick-off the loading once the configuration is ready.
if (process.env.forThemer) {
  // window.TurnTo defined in turnto.js
  window['TurnTo'].loadConfig = loadConfig
} else {
  waitForValue(() => window.TurnToPageConfig).then(() => {
    loadConfig(window.TurnToPageConfig)
  })
}
